import React, { memo, useEffect, useState } from "react";
import { createCustomer, createUser } from "../api/CustomerApi";
import { getAllRole } from "../api/RoleApi";
import { CustomerAutoSearch } from "../api/CustomerApi";
import { currentRegister } from "../utility/Constant";
import toast from "react-hot-toast";
import { getBranchId } from "utility/HeaderConfig";
import img1 from "images/login/loginBg.jpg";
import img2 from "images/login/signupBg.jpg";
import { useCartContext } from "context/UseCartContext";
import SEO from "./headers/Seo";

function RegisterModal() {
  const images = [img1, img2];
  const [name, setName] = useState("");
  const [mobileno, setmobileno] = useState("");
  const [email, setemail] = useState("");
  const [address, setaddress] = useState("");
  const [password, setpassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [invalidEmail, setinvalidEmail] = useState(false);
  const [invalidMobile, setInvalidMobile] = useState(false);
  const [emptyField, setEmptyField] = useState(false);
  const [availableEmail, setAvailableEmail] = useState(false);
  const [availableMobile, setAvailableMobile] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [nameError, setNameError] = useState("");
  const [addressError, setAddressError] = useState("");
  const [roleId, setRoleId] = useState(null);
  const [Loading, setLoading] = useState(false);
  const { dispatch } = useCartContext();
  const [currentImg, setCurrentImg] = useState(0);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    getAllRole({ name: "Customer" }).then((data) => {
      if (data.response.length > 0) setRoleId(data.response[0].id);
    });
    return () => { document.body.style.overflow = ""; };
  }, []);

  const close = () => dispatch({ type: "MODAL", payload: false });

  // Handle name change
  const handleNameChange = (value) => {
    const filtered = value.replace(/[^A-Za-z\s]/g, "");
    setName(filtered);
    setNameError("");
    setEmptyField(false);
  };

  // Handle password change (only numbers, max 4 digits)
  const handlePasswordChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 4);
    setpassword(value);
    setPasswordError("");
    setEmptyField(false);
  };

  // Handle email change with real-time validation
  const handleEmailChange = (e) => {
    const value = e.target.value.trim();
    setemail(value);
    setEmailError("");
    setinvalidEmail(false);
    setAvailableEmail(false);
    
    // Real-time email validation
    if (value && !isValidEmail(value)) {
      setEmailError("Please enter a valid email address");
      setinvalidEmail(true);
    }
  };

  // Handle mobile change with real-time validation
  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 10);
    setmobileno(value);
    setMobileError("");
    setInvalidMobile(false);
    setAvailableMobile(false);
    
    // Real-time mobile validation
    if (value && value.length > 0 && value.length !== 10) {
      setMobileError("Mobile number must be 10 digits");
      setInvalidMobile(true);
    }
  };

  // Handle address change
  const handleAddressChange = (e) => {
    setaddress(e.target.value);
    setAddressError("");
    setEmptyField(false);
  };

  const isValidEmail = (email) => {
    const emailReg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;//eslint-disable-line
    return emailReg.test(email);
  };

  const submitForm = (e) => {
    e.preventDefault();
    postAjaxRequest();
  };

  const postAjaxRequest = () => {
    const emailReg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;//eslint-disable-line
    const mobileReg = /^(\+\d{1,3}[- ]?)?\d{10}$/;

    const emailOk = emailReg.test(email);
    const mobileOk = mobileReg.test(mobileno);
    
    // Clear previous errors
    setEmailError("");
    setMobileError("");
    setPasswordError("");
    setNameError("");
    setAddressError("");
    
    let hasError = false;

    // Name validation
    if (!name.trim()) {
      setNameError("Full name is required");
      hasError = true;
    }
    
    // Email validation (required)
    if (!email) {
      setEmailError("Email address is required");
      hasError = true;
    } else if (!emailOk) {
      setEmailError("Please enter a valid email address (e.g., name@example.com)");
      setinvalidEmail(true);
      hasError = true;
    }

    // Mobile validation
    if (!mobileno) {
      setMobileError("Mobile number is required");
      hasError = true;
    } else if (!mobileOk) {
      setMobileError("Please enter a valid 10-digit mobile number");
      setInvalidMobile(true);
      hasError = true;
    }

    // Password validation
    if (!password) {
      setPasswordError("Password is required");
      hasError = true;
    } else if (password.length !== 4) {
      setPasswordError("Password must be exactly 4 digits");
      hasError = true;
    }

    // Address validation
    if (!address.trim()) {
      setAddressError("Address is required");
      hasError = true;
    }

    if (hasError) {
      setEmptyField(true);
      return;
    }

    // Check if mobile number already exists
    CustomerAutoSearch(`mobile=${mobileno}&beforeCreatedAt=${currentRegister()}`).then(
      (data) => {
        if (data.response && data.response.length > 0) {
          setMobileError("Account already exists with this mobile number. Please sign in instead.");
          setAvailableMobile(true);
          toast.error("Account already exists with this mobile number");
        } else {
          setAvailableMobile(false);
          setMobileError("");
          createUserAccount();
        }
      },
      (err) => {
        console.log(err);
        // If API fails, proceed with registration
        createUserAccount();
      }
    );
  };

  const createUserAccount = () => {
    setLoading(true);
    createUser(JSON.stringify({
      username: mobileno, password, rolesList: [roleId],
      email: email, branch: getBranchId(), employeeId: null,
    })).then(
      () => createCustomerFunc(),
      (err) => {
        setLoading(false);
        if (err.response && err.response.data) {
          const msg = err.response.data.displayMessage || err.response.data.message;
          if (msg) {
            // Show specific error under the respective field instead of toaster
            if (msg.toLowerCase().includes("user") || msg.toLowerCase().includes("already exists") || msg.toLowerCase().includes("mobile")) {
              setMobileError("Account already exists with this mobile number. Please sign in instead.");
              setAvailableMobile(true);
            } else if (msg.toLowerCase().includes("email")) {
              setEmailError("This email address is already registered. Please use a different email or sign in.");
              setAvailableEmail(true);
            } else {
              // For other errors, show in toaster
              toast.error(msg, { position: "top-right" });
            }
          } else {
            toast.error("Registration failed. Please try again.", { position: "top-right" });
          }
        } else if (err.message) {
          toast.error(err.message, { position: "top-right" });
        } else {
          toast.error("Registration failed. Please check your connection.", { position: "top-right" });
        }
      }
    );
  };

  const createCustomerFunc = () => {
    createCustomer(JSON.stringify({
      branchId: getBranchId(), name, mobile: mobileno, email: email,
      customerType: "CUSTOMER", enrollmentDate: currentRegister(),
      crmStatus: "ENGAGING", enquirySource: "WEB", religion: "NA",
      customerAddress: { address1: address },
    })).then(
      () => {
        setLoading(false);
        toast.success("Account created successfully! Please sign in.", { duration: 2500, position: "top-right" });
        setTimeout(() => dispatch({ type: "MODAL", payload: "login" }), 1000);
      },
      (err) => {
        setLoading(false);
        console.error("Customer creation error:", err);
        if (err.response && err.response.data) {
          const msg = err.response.data.displayMessage || err.response.data.message;
          if (msg && msg.toLowerCase().includes("email")) {
            setEmailError("Email registration failed. Please use a different email.");
          } else {
            toast.error(msg || "Failed to create customer profile. Please contact support.", { position: "top-right" });
          }
        } else {
          toast.error("Failed to create customer profile. Please try again.", { position: "top-right" });
        }
      }
    );
  };

  const hasErr = (cond) => cond ? "#e53e3e" : "#e5e5ea";

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImg((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  // eslint-disable-next-line
  }, []);

  return (
    <>
      <SEO title="Create Account — PMR Venkateswara Jewellery" description="Register." name="PMR Venkateswara Jewellery" type="article" />

      <div style={{ position: "fixed", inset: 0, zIndex: 99999, display: "flex", alignItems: "center", justifyContent: "center", padding: 16, animation: "ejFadeIn .2s ease" }}>
        {/* Backdrop */}
        <div onClick={close} style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,.55)", backdropFilter: "blur(6px)", WebkitBackdropFilter: "blur(6px)" }} />

        {/* Card */}
        <div onClick={(e) => e.stopPropagation()} style={{ position: "relative", zIndex: 1, background: "#fff", borderRadius: 20, boxShadow: "0 24px 80px rgba(0,0,0,.2)", width: "100%", maxWidth: 800, maxHeight: "90vh", display: "flex", overflow: "hidden", animation: "ejScaleIn .24s cubic-bezier(.16,1,.3,1)" }}>

          {/* Left image */}
          <div style={{ width: "42%", flexShrink: 0, position: "relative" }}>
            <img src={images[currentImg]} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
            <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to top,rgba(0,0,0,.75) 0%,rgba(0,0,0,.1) 60%)", display: "flex", alignItems: "flex-end", padding: 28 }}>
              <div>
                <p style={{ margin: "0 0 6px", fontSize: 11, fontWeight: 700, letterSpacing: ".12em", textTransform: "uppercase", color: "#e0c17e" }}>Join Us Today</p>
                <h2 style={{ fontFamily: "var(--font-display,Georgia,serif)", fontSize: 24, fontWeight: 500, color: "#fff", margin: 0 }}>Your journey begins here</h2>
              </div>
            </div>
          </div>

          {/* Right form */}
          <div style={{ flex: 1, padding: "32px 32px", overflowY: "auto", position: "relative" }}>
            <button onClick={close} style={{ position: "absolute", top: 16, right: 16, width: 30, height: 30, borderRadius: "50%", background: "#f2f2f7", border: "none", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: "#6c6c70" }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>

            <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: ".14em", textTransform: "uppercase", color: "#9c7a3a", margin: "0 0 4px" }}>New Customer</p>
            <h2 style={{ fontFamily: "var(--font-display,Georgia,serif)", fontSize: 26, fontWeight: 500, color: "#6b5330", margin: "0 0 4px" }}>Create Account</h2>
            <p style={{ fontSize: 13, color: "#f6d78e", margin: "0 0 20px" }}>Join thousands who trust PMR Venkateswara Jewellery</p>

            <form onSubmit={submitForm} noValidate>
              {/* Full Name */}
              <div style={{ marginBottom: 13 }}>
                <label style={labelStyle}>Full Name</label>
                <div style={{ position: "relative" }}>
                  <span style={prefixStyle}>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
                      <circle cx="12" cy="7" r="4"/>
                    </svg>
                  </span>
                  <input 
                    type="text" 
                    value={name} 
                    onChange={(e) => handleNameChange(e.target.value)} 
                    placeholder="Your full name"
                    style={{ ...inputStyle, paddingLeft: 42, borderColor: hasErr(nameError || (emptyField && !name)) }} 
                  />
                </div>
                {(emptyField && !name && !nameError) && <span style={errStyle}>Name is required</span>}
                {nameError && <span style={errStyle}>{nameError}</span>}
              </div>

              {/* Mobile Number */}
              <div style={{ marginBottom: 13 }}>
                <label style={labelStyle}>Mobile Number</label>
                <div style={{ position: "relative" }}>
                  <span style={prefixStyle}>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.95 9.91a19.79 19.79 0 01-3.07-8.67A2 2 0 012.88 1h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L7.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.34 1.85.574 2.81.7A2 2 0 0122 16.92z"/>
                    </svg>
                  </span>
                  <input 
                    type="tel" 
                    value={mobileno} 
                    onChange={handleMobileChange}
                    placeholder="10-digit mobile number"
                    maxLength={10}
                    style={{ ...inputStyle, paddingLeft: 42, borderColor: hasErr(mobileError || (emptyField && !mobileno) || invalidMobile || availableMobile) }} 
                  />
                </div>
                {(emptyField && !mobileno && !mobileError) && <span style={errStyle}>Mobile number is required</span>}
                {mobileError && <span style={errStyle}>{mobileError}</span>}
                {!mobileError && invalidMobile && <span style={errStyle}>Invalid mobile number</span>}
                {!mobileError && availableMobile && <span style={errStyle}>Already registered</span>}
              </div>

              {/* Email Address */}
              <div style={{ marginBottom: 13 }}>
                <label style={labelStyle}>Email Address</label>
                <div style={{ position: "relative" }}>
                  <span style={prefixStyle}>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                      <polyline points="22,6 12,13 2,6"/>
                    </svg>
                  </span>
                  <input 
                    type="email" 
                    value={email} 
                    onChange={handleEmailChange}
                    placeholder="you@example.com"
                    style={{ ...inputStyle, paddingLeft: 42, borderColor: hasErr(emailError || (emptyField && !email) || invalidEmail || availableEmail) }} 
                  />
                </div>
                {(emptyField && !email && !emailError) && <span style={errStyle}>Email address is required</span>}
                {emailError && <span style={errStyle}>{emailError}</span>}
                {!emailError && invalidEmail && <span style={errStyle}>Invalid email address</span>}
                {!emailError && availableEmail && <span style={errStyle}>Email already registered</span>}
              </div>

              {/* Address */}
              <div style={{ marginBottom: 13 }}>
                <label style={labelStyle}>Address</label>
                <div style={{ position: "relative" }}>
                  <span style={prefixStyle}>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
                      <circle cx="12" cy="10" r="3"/>
                    </svg>
                  </span>
                  <input 
                    type="text" 
                    value={address} 
                    onChange={handleAddressChange}
                    autoComplete="off"
                    placeholder="Your address"
                    style={{ ...inputStyle, paddingLeft: 42, borderColor: hasErr(addressError || (emptyField && !address)) }} 
                  />
                </div>
                {(emptyField && !address && !addressError) && <span style={errStyle}>Address is required</span>}
                {addressError && <span style={errStyle}>{addressError}</span>}
              </div>

              {/* Password */}
              <div style={{ marginBottom: 16 }}>
                <label style={labelStyle}>Password (4-digit numeric)</label>
                <div style={{ position: "relative" }}>
                  <span style={prefixStyle}>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="11" width="18" height="11" rx="2"/>
                      <path d="M7 11V7a5 5 0 0110 0v4"/>
                    </svg>
                  </span>
                  <input 
                    type={showPassword ? "text" : "password"} 
                    inputMode="numeric"
                    pattern="[0-9]{4}"
                    value={password} 
                    onChange={handlePasswordChange} 
                    placeholder="Create a 4-digit numeric password"
                    autoComplete="off"
                    maxLength={4}
                    style={{ ...inputStyle, paddingLeft: 42, paddingRight: 42, borderColor: hasErr((emptyField && !password) || passwordError) }} 
                  />
                  <button 
                    type="button" 
                    onClick={() => setShowPassword((v) => !v)} 
                    style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "#98989d", display: "flex" }}
                  >
                    {showPassword
                      ? <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                      : <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>}
                  </button>
                </div>
                {(emptyField && !password && !passwordError) && <span style={errStyle}>Password is required</span>}
                {passwordError && <span style={errStyle}>{passwordError}</span>}
                {password && password.length > 0 && password.length < 4 && !passwordError && (
                  <span style={errStyle}>Password must be 4 digits (current: {password.length}/4)</span>
                )}
              </div>

              <button type="submit" disabled={Loading} style={btnStyle}>
                {Loading ? "Creating account…" : "Create Account"}
              </button>
            </form>

            <p style={{ fontSize: 13, color: "#0e0c0c", textAlign: "center", marginTop: 14 }}>
              Already have an account?{" "}
              <button style={linkBtnStyle} onClick={() => dispatch({ type: "MODAL", payload: "login" })}>Sign in</button>
            </p>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes ejFadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes ejScaleIn { from { opacity: 0; transform: scale(.96); } to { opacity: 1; transform: scale(1); } }
        @media (max-width: 600px) {
          .pmr-modal-side-img-wrap { display: none !important; }
        }
      `}</style>
    </>
  );
}

const labelStyle = { display: "block", fontSize: 11, fontWeight: 600, color: "#6d551e", letterSpacing: ".07em", textTransform: "uppercase", marginBottom: 6 };
const prefixStyle = { position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", color: "#6d551e", pointerEvents: "none", display: "flex", alignItems: "center" };
const inputStyle = { display: "block", width: "100%", padding: "11px 14px", fontFamily: "inherit", fontSize: 14, color: "#6d551e", background: "#fafafa", border: "1.5px solid #e5e5ea", borderRadius: 8, outline: "none" };
const errStyle = { display: "block", fontSize: 11.5, color: "#e53e3e", marginTop: 4 };
const btnStyle = { display: "flex", alignItems: "center", justifyContent: "center", width: "100%", padding: 13, background: "#6b5330", color: "#fff", fontSize: 14, fontWeight: 600, letterSpacing: ".05em", border: "none", borderRadius: 8, cursor: "pointer", transition: "background .14s" };
const linkBtnStyle = { color: "#e0c17e", fontWeight: 600, background: "none", border: "none", padding: 0, cursor: "pointer", textDecoration: "underline", fontSize: "inherit" };

export default memo(RegisterModal);